import { AbstractPaintableItem } from "./AbstractPaintableItem";
import { TypeKeys } from "./TypeKeys";
import { IExpandable } from "./IExpandable";
import { Rectangle } from "../../../domain/drawing/Rectangle";
import { Size } from "../../../domain/drawing/Size";

export class BoxLineItem extends AbstractPaintableItem implements IExpandable {
  constructor() {
    super(TypeKeys.BoxLineItem);
  }
 
  protected createCloneInstance(): BoxLineItem {
    return new BoxLineItem();
  }

  expandToBottom(value: number): void {
    const rect = this.geometry.rectangle;
    this.geometry.rectangle = new Rectangle(rect.topLeft, new Size(rect.size.width, rect.size.height + value));
  }
}
